import React from "react";


export const MusicContext = React.createContext()
